<!-- <li class="panel"> -->
<div class="controparte">
	<p class="col-sm-2">
		<button (click)="emitEntity(atto)"
			class="btn btn-primary associa" type="submit">Allega</button>
	</p>
	<div>
		<h4 class="titolo col-sm-5">
			{{atto.tipoAtto.descrizione}}
		</h4>
		<p class="col-sm-2">
			<strong>{{atto.provenienza.descrizione}}</strong>
		</p>
		<p class="col-sm-2">
			Data <strong>{{ atto.dataProtocollo ? (atto.dataProtocollo |
				date:'dd/MM/yyyy'): '' }}</strong>
		</p>
		<p class="col-sm-3">
			N&deg; protocollo: <strong>{{ atto.numeroProtocollo ?
				atto.numeroProtocollo: '' }}</strong>
		</p>
	</div>
</div>
<!-- </li> -->
